export const CaretSvg = ({ size = 9, color = "#002551" }) => {
	const ratio = 9 / 14;

	return (
		<svg
			width={size}
			height={size * ratio}
			viewBox="0 0 9 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.5 0.75L7.75 7L1.5 13.25"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
